import { Injectable, NgZone } from '@angular/core';
import { BadgeQuery } from '../badge/badge.query';
import { SettingsBackendService } from '../../services/settings/settings-backend.service';
import { SessionQuery } from '../session/session.query';
import { SettingsQuery } from '../settings/settings.query';
import { OrderListQuery } from '../order-list/order-list.query';
import { CostCenterListQuery } from '../cost-center-list/cost-center-list.query';
import { OperationListQuery } from '../operation-list/operation-list.query';
import { NoteItemsQuery } from '../entities/note-items/note-items.query';
import { QuantityItemsQuery } from '../entities/quantity-items/quantity-items.query';
import { ExpensesItemsQuery } from '../entities/expenses-items/expenses-items.query';
import { MaterialItemsQuery } from '../entities/material-items/material-items.query';
import { DayInfoQuery } from '../day-info/day-info.query';
import { SettingsService } from '../settings/settings.service';
import { OrderListService } from '../order-list/order-list.service';
import { CostCenterListService } from '../cost-center-list/cost-center-list.service';
import { OperationListService } from '../operation-list/operation-list.service';
import { NoteItemsService } from '../entities/note-items/note-items.service';
import { MaterialItemsService } from '../entities/material-items/material-items.service';
import { ExpensesItemsService } from '../entities/expenses-items/expenses-items.service';
import { QuantityItemsService } from '../entities/quantity-items/quantity-items.service';
import { DayInfoService } from '../day-info/day-info.service';
import { ThemeService } from '../../services/theme/theme.service';
import { AbsencePlanerQuery } from '../absence-planer/absence-planer.query';
import { AbsencePlanerService } from '../absence-planer/absence-planer.service';
import { SideMenuService } from '../side-menu/side-menu.service';
import { SideMenuQuery } from '../side-menu/side-menu.query';
import { Router } from '@angular/router';
import { AppConfig } from '../../services/config.service';
import { ISavedListSettingsService } from '../../interfaces/settings/saved-list-settings.service';
import { ISavedListSettingsQuery } from '../../interfaces/settings/saved-list-settings.query';
import { TableColumn } from '../../models/table-column';
import { createInitialBadgeState } from '../badge/badge.store';
import { PersonalListService } from '../personal-list/personal-list.service';
import { PersonalListQuery } from '../personal-list/personal-list.query';
import { WebAppSettingsModel } from '../../models/client-models';
import { BadgeService } from '../badge/badge.service';

@Injectable({
  providedIn: 'root',
})
export class SqlSettingsService {
  private lastUpdate = {} as any;

  private updateItemsConfig: Array<{
    key: string;
    service: ISavedListSettingsService;
    query: ISavedListSettingsQuery;
  }> = [
    //   {
    //     key: 'noteList',
    //     service: this.noteItemsService,
    //     query: this.noteItemsQuery,
    //   },
    //   {
    //     key: 'materialList',
    //     service: this.materialItemsService,
    //     query: this.materialItemsQuery,
    //   },
    //   {
    //     key: 'expensesList',
    //     service: this.expensesItemsService,
    //     query: this.expensesItemsQuery,
    //   },
    //   {
    //     key: 'quantityList',
    //     service: this.quantityItemsService,
    //     query: this.quantityItemsQuery,
    //   },
    //   {
    //     key: 'orderList',
    //     service: this.orderListService,
    //     query: this.orderListQuery,
    //   },
    //   {
    //     key: 'costCenterList',
    //     service: this.costCenterListService,
    //     query: this.costCenterQuery,
    //   },
    //   {
    //     key: 'operationList',
    //     service: this.operationListService,
    //     query: this.operationListQuery,
    //   },
    //   {
    //     key: 'dayInfoQuery',
    //     service: this.dayInfoService,
    //     query: this.dayInfoQuery,
    //   },
    //   {
    //     key: 'personalList',
    //     service: this.personalListService,
    //     query: this.personalListQuery,
    //   },
  ];

  constructor(
    private settingsBackendService: SettingsBackendService,
    private sessionQuery: SessionQuery,
    private settingsQuery: SettingsQuery,
    private settingsService: SettingsService,
    private sideMenuService: SideMenuService,
    private sideMenuQuery: SideMenuQuery,
    private ngZone: NgZone,
    private router: Router,
    private theme: ThemeService,
    private badgeQuery: BadgeQuery,
    private badgeService: BadgeService
  ) {}

  getSettingsFromDB() {
    this.settingsBackendService
      .getSettings(
        this.sessionQuery.getPersonID(),
        this.sessionQuery.getAdmiaUserID()
      )
      .subscribe((value) => {
        if (value) {
          // console.log(value.value, 'settings from db');
          if (value.value !== '') {
            if (this.checkMigrationNeeded(value)) {
              value = this.migrateSettings(value);
            }
            this.updateSettingsFromDB(value);
          }
        }
      });
  }

  getCurrentSettingsString() {
    const badgeSettings = this.badgeQuery.getSettings();
    const settingsState = this.settingsQuery.getValue();

    const resultObject = {} as any;

    if (badgeSettings) {
      resultObject.badge = badgeSettings;
    } else {
      resultObject.badge = this.lastUpdate.badge;
    }

    if (settingsState) {
      resultObject.settings = settingsState;
    } else {
      resultObject.settings = this.lastUpdate.settings;
    }

    // if (this.sideMenuQuery.getSettings()) {
    //   resultObject.sideMenu = {
    //     settings: this.sideMenuQuery.getSettings(),
    //   };
    // } else {
    //   resultObject.sideMenu = this.lastUpdate.sideMenu;
    // }

    // const absencePlanerSettings = this.absencePlanerQuery.getSettings();
    // if (absencePlanerSettings?.grouping) {
    //   resultObject.absencePlanerSettings = absencePlanerSettings;
    // } else {
    //   resultObject.absencePlanerSettings =
    //     this.lastUpdate.absencePlanerSettings;
    // }

    // list items columns and filter settings
    for (const item of this.updateItemsConfig) {
      try {
        if (item.query.getTableColumns()) {
          let filter: any;
          if (item.query.hasFilter()) {
            if (item.query.newFilterStructure()) {
              filter = item.query.getFilterColumns();
            } else {
              filter = item.query.filterOptions();
            }
          }

          resultObject[item.key] = {
            columns: item.query.getTableColumns(),
            filterOptions: filter,
          };
        } else {
          resultObject[item.key] = this.lastUpdate[item.key];
        }
      } catch (e) {
        console.log('Failed to get local setting ', item, e);
      }
    }
    return JSON.stringify(resultObject);
  }

  // saveSettingsToDB(value?: WebAppSettingsModel) {
  //   const idPerson = this.sessionQuery.getPersonID();
  //   const idAdmiaUser = this.sessionQuery.getAdmiaUserID();

  //   return this.settingsBackendService.setSettings({
  //     idPerson,
  //     idAdmiaUser,
  //     version: AppConfig.settings.version,
  //     minorVersion: AppConfig.settings.minorVersion,
  //     value: value ? value.value : this.getCurrentSettingsString(),
  //   } as WebAppSettingsModel);
  // }

  checkMigrationNeeded(savedSettings: WebAppSettingsModel): boolean {
    // console.log(savedSettings.version)

    return (
      !savedSettings?.version ||
      savedSettings.minorVersion !== AppConfig.settings.minorVersion ||
      savedSettings.version !== AppConfig.settings.version
    );
  }

  updateSettingsFromDB(
    savedSettings: WebAppSettingsModel,
    migrated: boolean = false
  ) {
    if (savedSettings && savedSettings?.value !== '') {
      const settings = JSON.parse(savedSettings.value);
      this.lastUpdate = settings;

      // if (settings.settings) {
      //   this.theme.changeThemeMode(settings.settings.darkMode);
      //   this.theme.changeTheme(settings.settings.theme);
      //   this.settingsService.setSettings(settings.settings);
      // }

      for (const item of this.updateItemsConfig) {
        if (!settings.hasOwnProperty(item.key)) {
          console.log('no settings for', item.key);
        }

        if (settings.hasOwnProperty(item.key) && settings[item.key].columns) {
          if (item.query.hasFilter()) {
            item.service.setFilterOptions(settings[item.key].filterOptions);
          }
          item.service.showSelectedColumns(settings[item.key].columns);
        }
      }

      // if (settings.sideMenu.settings) {
      //   if (
      //     JSON.stringify(settings.sideMenu.settings) !== JSON.stringify(this.sideMenuQuery.getSettings()) || migrated)
      //   {
      //     this.sideMenuService.saveSettings(settings.sideMenu.settings);
      //     // if (!this.sideMenuService.isActive(this.router.url)) {
      //     //   this.ngZone.run(() => {
      //     //     this.router.navigateByUrl(this.sideMenuQuery.getFirstActive());
      //     //   });
      //     // }
      //   }
      // }

      // if (settings.badge) {
      //   this.badgeService.saveSettings(settings.badge);
      // }

      // if (settings?.absencePlanerSettings?.grouping) {
      //   this.absencePlanerService.setGrouping(
      //     settings?.absencePlanerSettings?.grouping
      //   );
      // }

      // if (settings?.absencePlanerSettings?.filter) {
      //   this.absencePlanerService.setFilter(
      //     settings?.absencePlanerSettings?.filter
      //   );
      // }

      // if (settings?.absencePlanerSettings?.filterID) {
      //   this.absencePlanerService.setFilterID(
      //     settings?.absencePlanerSettings?.filterID
      //   );
      // }
    }
  }

  migrateSettings(savedSettings: WebAppSettingsModel): WebAppSettingsModel {
    // console.log(savedSettings, 'savedsettings migratesettings method');
    if (!savedSettings.version || savedSettings.version < 23) {
      savedSettings = this.migrateToV23M0(savedSettings);
    }
    // console.log(savedSettings.version)
    if (savedSettings.version <= 24) {
      savedSettings = this.migrateToV24(savedSettings);
    }
    return savedSettings;
  }

  //NOTE Version 23 Migration
  private migrateToV23M0(
    savedSettings: WebAppSettingsModel
  ): WebAppSettingsModel {
    let settings = this.migrateColumnsAndFilterOptions(savedSettings);

    // migrate side-menu add new items and remove old ones
    const oldSideMenu = settings.sideMenu;
    // const newSideMenu = createInitialSideMenuState();

    // settings.sideMenu.settings = this.migrateTableColumns(
    //   oldSideMenu.settings,
    //   newSideMenu.settings
    // );

    // Migrate badge settings
    const oldBadge = settings.badge;
    const newBadge = createInitialBadgeState(this.sessionQuery);
    settings.badge = this.migrateTableColumns(
      oldBadge.settings,
      newBadge.settings
    );

    savedSettings.minorVersion = 0;
    savedSettings.version = 23;
    savedSettings.value = JSON.stringify(settings);

    return savedSettings;
  }

  //NOTE Version 24 Migration
  private migrateToV24(
    savedSettings: WebAppSettingsModel
  ): WebAppSettingsModel {
    let settings = this.migrateColumnsAndFilterOptions(savedSettings);
    // console.log('migrate to v24');
    // migrate side-menu add new items and remove old ones
    const oldSideMenu = settings.sideMenu;
    // const newSideMenu = createInitialSideMenuState();

    // settings.sideMenu.settings = this.migrateTableColumns(
    //   oldSideMenu.settings,
    //   newSideMenu.settings
    // );

    savedSettings.minorVersion = 0;
    savedSettings.version = 24;
    savedSettings.value = JSON.stringify(settings);

    return savedSettings;
  }

  private migrateColumnsAndFilterOptions(savedSettings: WebAppSettingsModel) {
    let settings = JSON.parse(savedSettings.value);

    for (const item of this.updateItemsConfig) {
      const initialColumns = JSON.parse(
        JSON.stringify(item.query.getInitialColumns())
      );

      if (settings[item.key]) {
        settings[item.key].columns = this.migrateTableColumns(
          settings[item.key].columns,
          initialColumns
        );
        if (item.query.hasFilter()) {
          settings[item.key].filterOptions = this.migrateFilterOptions(
            item.query,
            settings[item.key].filterOptions,
            JSON.parse(JSON.stringify(item.query.getInitialFilter()))
          );
        }
      } else {
        if (item.query.hasFilter()) {
          settings[item.key] = {
            columns: initialColumns,
            filterOptions: item.query.getInitialFilter(),
          };
        } else {
          settings[item.key] = {
            columns: initialColumns,
          };
        }
      }
    }
    return settings;
  }

  private migrateTableColumns(
    oldColumns: TableColumn[],
    newColumns: TableColumn[]
  ): TableColumn[] {
    if (!oldColumns) {
      return newColumns;
    }
    return newColumns.map((col) => {
      const oldCol = oldColumns.find((old) => old.name === col.name);
      if (oldCol) {
        if (col.hasOwnProperty('disabled')) {
          col.disabled = oldCol.disabled;
        }
        col.selected = oldCol.selected;
        col.position = oldCol.position;
      }
      return col;
    });
  }

  private migrateFilterOptions(
    query: ISavedListSettingsQuery,
    oldFilterOptions: any,
    newFilterOptions: any
  ): any {
    const filterStructure = query.newFilterStructure();

    if (filterStructure) {
      return query.getInitialFilter();
    } else {
      for (const filterKey in oldFilterOptions) {
        if (
          oldFilterOptions.hasOwnProperty(filterKey) &&
          newFilterOptions.hasOwnProperty(filterKey)
        ) {
          const newFilterOption = newFilterOptions[filterKey];
          const oldFilterOption = oldFilterOptions[filterKey];

          newFilterOption.selected = oldFilterOption.selected;
        }
      }
      return newFilterOptions;
    }
  }
}
